import React from "react";
import { useTruncateText } from "./hooks/useTruncateText";

export interface TruncateTextProps {
  text: string;
  ellipsis?: string;
  onTruncated?: (isTruncated: boolean) => void;
  containerRef?: React.RefObject<HTMLElement | null>;
  containerOffset?: number;
}

const CustomTruncateText: React.FC<TruncateTextProps> = ({
  text,
  ellipsis = "...",
  onTruncated,
  containerRef,
  containerOffset,
}) => {
  const { ref, truncatedText, isTruncated } = useTruncateText({
    text,
    ellipsis,
    containerRef,
    containerOffset,
  });
  const prevIsTruncatedRef = React.useRef<boolean | undefined>(undefined);

  React.useEffect(() => {
    if (onTruncated && prevIsTruncatedRef.current !== isTruncated) {
      prevIsTruncatedRef.current = isTruncated;
      onTruncated(isTruncated);
    }
  }, [isTruncated, onTruncated]);

  return (
    <span
      ref={ref}
      style={{
        display: "block",
        width: containerRef ? undefined : "100%",
        overflow: containerRef ? "visible" : "hidden",
        whiteSpace: "nowrap",
      }}
    >
      {truncatedText}
    </span>
  );
};

export default CustomTruncateText;
